import { Do, guid, leftpad, timer } from '../../universal';
import { $, _, renderToStaticMarkup } from '../lib';
import { IRIS } from './component-iris';
import { j2h } from './component-j2h';
import { newSystemFlyout } from './flyouts';
export const Components = {
    Dropdown: (obj = {}) => {
        const value = obj.value ?? null;
        const model = obj.model ?? null;
        const multiple = obj.multiple ?? false;
        const options = obj.options ?? null;
        const evChange = obj.change ?? _.noop;
        const className = obj.class ?? 'tb2';
        const disabled = obj.disabled ?? false;
        const M = {
            tag: 'select',
            class: className,
            value,
            model: null,
            attr: {},
            children: options.map((opt) => {
                if (Array.isArray(opt)) {
                    return {
                        tag: 'option',
                        value: opt[0],
                        text: opt[1],
                    };
                }
                return {
                    tag: 'optgroup',
                    attr: { label: opt.label },
                    children: opt.children.map((o) => ({
                        tag: 'option',
                        value: o[0],
                        text: o[1],
                    })),
                };
            }),
            ev: {
                init: (elem) => {
                    if (value != null) {
                        elem.value = value;
                    }
                    ;
                    (obj.init ?? _.noop)(elem);
                },
                change: evChange,
            },
        };
        if (multiple) {
            M.attr.multiple = null;
            M.class += ' multiple';
        }
        if (model != null) {
            M.model = model;
        }
        if (disabled) {
            M.attr.disabled = true;
        }
        return M;
    },
    Button: (lbl, class_, onClick) => {
        const onClickHandler = onClick ?? _.noop;
        return {
            tag: 'input',
            class: class_,
            value: lbl,
            attr: { type: 'button' },
            click: (e, $elem) => onClickHandler(e, $elem),
        };
    },
};
export const Alerts = {
    Base: (obj) => {
        if (obj.title == null) {
            obj.title = 'No title given';
        }
        if (obj.msg == null) {
            obj.msg = 'No message given';
        }
        if (obj.buttons == null) {
            obj.buttons = [['OK', 'btnSubmit2', _.noop, true]];
        }
        if (obj.load == null) {
            obj.load = _.noop;
        }
        if (obj.size == null) {
            obj.size = [360, 200];
        }
        if (obj.cl == null) {
            obj.cl = '';
        }
        if (obj.msg && typeof obj.msg === 'object') {
            obj.msg = renderToStaticMarkup(obj.msg);
        }
        const flyout = newSystemFlyout({
            size: obj.size,
            cl: obj.cl,
            closeCallback: obj.no ?? _.noop,
        });
        const $form = $(flyout.Element);
        $form.append(j2h([
            {
                class: 'flyout_header',
                children: [
                    {
                        tag: 'h1',
                        attr: { style: 'display: inline;' },
                        text: obj.title,
                    },
                ],
            },
            {
                class: 'floater_body toDialog',
                children: [
                    { tag: 'p', html: obj.msg },
                    {
                        class: 'buttons cntr',
                        children: _.map(obj.buttons, btn => {
                            const [lbl, class_, onclick, isFocused] = btn;
                            const M = {
                                tag: 'input',
                                class: class_,
                                value: lbl,
                                attr: { type: 'button' },
                                click: () => {
                                    flyout.Close();
                                    onclick?.($form);
                                },
                            };
                            if (isFocused) {
                                M.ev = {
                                    init: (elem) => timer(() => elem?.focus()),
                                };
                            }
                            return M;
                        }),
                    },
                ],
            },
        ]));
        obj.load();
        $form.find('.floater_body');
    },
    Confirm: (obj) => {
        if (obj.title == null) {
            obj.title = 'Are you sure?';
        }
        if (obj.msg == null) {
            obj.msg = 'Are you sure you want to perform this action?';
        }
        if (obj.yes == null) {
            obj.yes = _.noop;
        }
        if (obj.no == null) {
            obj.no = _.noop;
        }
        if (obj.buttons == null) {
            obj.buttons = [
                ['OK', 'btnSubmit2', obj.yes, true],
                ['Cancel', 'btnStandard2', obj.no, false],
            ];
        }
        Alerts.Base(obj);
    },
    ConfirmWithOption: (obj) => {
        if (obj['label'] == null) {
            console.error('Must define `label` to `ConfirmWithOption`');
        }
        const onYesClick = obj['yes'] ?? _.noop;
        const thisGUID = guid();
        obj['msg'] = Do(() => {
            const dom = {
                children: [
                    {
                        tag: 'p',
                        text: obj['msg'] ?? 'Are you sure you want to perform this action?',
                    },
                    {
                        tag: 'label',
                        class: 'label noselect',
                        children: [
                            {
                                tag: 'input',
                                attr: {
                                    type: 'checkbox',
                                    id: thisGUID,
                                },
                            },
                            String(obj['label'] ?? 'No label defined'),
                        ],
                    },
                ],
            };
            return j2h(dom).outerHTML;
        });
        obj['yes'] = ($form) => {
            const checkbox = $form.find(`[id='${thisGUID}']`)[0];
            const is_checked = checkbox?.checked ?? false;
            if (typeof onYesClick === 'function') {
                onYesClick(is_checked);
            }
        };
        if (obj['title'] == null) {
            obj['title'] = 'Are you sure?';
        }
        if (obj['no'] == null) {
            obj['no'] = _.noop;
        }
        if (obj['buttons'] == null) {
            obj['buttons'] = [
                ['OK', 'btnSubmit2', obj['yes'], true],
                ['Cancel', 'btnStandard2', obj['no'], false],
            ];
        }
        Alerts.Base(obj);
    },
    Alert: (obj) => {
        if (obj['title'] == null) {
            obj['title'] = 'Message';
        }
        if (obj['size'] == null) {
            obj['size'] = [300, 190];
        }
        obj['buttons'] = [['OK', 'btnSubmit2', obj['yes'], true]];
        Alerts.Base(obj);
    },
    DownloadReady: (obj) => {
        const msg = obj.msg ?? 'Your file is ready to download.';
        const title = obj.title ?? 'Download Ready';
        const url = obj.url;
        Alerts.Base({
            title: title,
            msg: msg,
            buttons: [
                ['Download', 'btnSubmit2', () => window.open(url, '_blank'), true],
                ['Dismiss', 'btnStandard2', _.noop, false],
            ],
            size: [360, 200],
        });
    },
};
export const validateTime = (string) => {
    if (!string) {
        return '';
    }
    string = string.trim();
    if (string.split(':').length == 3) {
        string = string.split(':').slice(0, 2).join(':');
    }
    string = string.replace(/\D/g, '');
    if (string.length === 0) {
        return '';
    }
    if (string.length <= 2) {
        string += '00';
    }
    string = leftpad(string, 4);
    let h = +string.substring(0, 2);
    let m = +string.substring(2, 4);
    if (!(h >= 0 && h <= 24)) {
        h = 0;
    }
    if (!(m >= 0 && m <= 60)) {
        m = 0;
    }
    return `${leftpad(String(h), 2)}:${leftpad(String(m), 2)}`;
};
export const sendErrorsToTelegram = () => {
    window.onerror = (message, url, line, _col, err) => {
        IRIS.Send({
            data: {
                progID: 0,
                funcID: 7,
                browser: navigator?.userAgent ?? 'Unknown',
                message,
                stack: err?.stack ?? null,
                url,
                line,
                location: location.href,
            },
        });
    };
};
export const enableButtons = ($btn) => {
    $btn = $btn.parent().children('input, button');
    $btn.removeClass('disabled').prop('disabled', false);
};
export const disableButtons = ($btn) => {
    $btn = $btn.parent().children('input, button');
    $btn.addClass('disabled').prop('disabled', true);
};
let scrollbarWidthCache = null;
export const getScrollbarWidth = () => {
    if (scrollbarWidthCache != null) {
        return scrollbarWidthCache;
    }
    const div = j2h({
        attr: {
            style: 'width:50px;height:50px;position:absolute;left:-50px;top:-50px;overflow:auto;',
        },
        children: [{ attr: { style: 'width:1px;height:100px;' } }],
    });
    document.body.appendChild(div);
    scrollbarWidthCache = div.offsetWidth - div.clientWidth;
    div.remove();
    $('head').append($(`<style>.allButScrollbar{width:calc(100% - ${scrollbarWidthCache}px)}`));
    return scrollbarWidthCache;
};
export const clearScrollbarWidthCache = () => {
    scrollbarWidthCache = null;
};
export const makeDraggable = (options) => {
    const getElement = (v) => {
        if (v == null) {
            return null;
        }
        if (typeof v === 'function') {
            return v();
        }
        return v;
    };
    let normalizedOptions;
    const normaliseParameters = () => {
        const opts = options ?? {};
        normalizedOptions = {
            $element: getElement(opts.$element),
            $handle: getElement(opts.$handle),
            onStart: opts.onStart ?? _.noop,
            onDuring: opts.onDuring ?? _.noop,
            onStop: opts.onStop ??
                ((data) => {
                    const pos = normalizedOptions.$element?.position();
                    if (pos && normalizedOptions.$element) {
                        const delta = data.pos?.delta;
                        normalizedOptions.$element.css({
                            left: pos.left + (delta?.x ?? 0),
                            top: pos.top + (delta?.y ?? 0),
                            transform: '',
                        });
                    }
                }),
            polling: opts.polling ?? 30,
            grid: opts.grid ?? 1,
            allowHorizontal: opts.allowHorizontal ?? true,
            allowVertical: opts.allowVertical ?? true,
            stopProp: opts.stopProp ?? true,
            data: (opts.data ?? {}),
        };
        normalizedOptions.data.options = normalizedOptions;
    };
    const getDelta = (o, n) => normalizedOptions.grid * Math.floor((o - n) / normalizedOptions.grid);
    const dragMove = (e) => {
        const touchEvent = e.originalEvent;
        const cx = e.pageX ?? touchEvent?.touches[0]?.pageX ?? 0;
        const cy = e.pageY ?? touchEvent?.touches[0]?.pageY ?? 0;
        const posData = normalizedOptions.data['pos'];
        if (!posData) {
            return;
        }
        let dx = getDelta(cx, posData.init.x);
        let dy = getDelta(cy, posData.init.y);
        dx = normalizedOptions.allowHorizontal ? dx : 0;
        dy = normalizedOptions.allowVertical ? dy : 0;
        posData.delta = { x: dx, y: dy };
        posData.current = {
            x: posData.init.x + dx,
            y: posData.init.y + dy,
        };
        normalizedOptions.$element?.css({ transform: `translate(${dx}px, ${dy}px)` });
        normalizedOptions.data['event'] = e;
        normalizedOptions.onDuring(normalizedOptions.data);
    };
    const dragMoveThrottled = _.throttle(dragMove, 30);
    const onMouseMoveThis = (e) => {
        dragMoveThrottled(e);
    };
    const onMouseUpThis = (e) => {
        const $window = normalizedOptions.data['$window'];
        $window?.off('mousemove touchmove', onMouseMoveThis);
        $window?.off('mouseup touchend', onMouseUpThis);
        dragMoveThrottled.cancel();
        normalizedOptions.data['event'] = e;
        normalizedOptions.onStop(normalizedOptions.data);
    };
    const startDrag = (e) => {
        normaliseParameters();
        if (normalizedOptions.stopProp) {
            e.stopPropagation();
            e.preventDefault();
        }
        normalizedOptions.data['$window'] = $(window);
        const touchEvent = e.originalEvent;
        const cx = e.pageX ?? touchEvent?.touches[0]?.pageX ?? 0;
        const cy = e.pageY ?? touchEvent?.touches[0]?.pageY ?? 0;
        normalizedOptions.data['pos'] = {
            init: { x: cx, y: cy },
            delta: { x: 0, y: 0 },
            current: { x: cx, y: cy },
        };
        const $window = normalizedOptions.data['$window'];
        $window.on('mousemove touchmove', onMouseMoveThis);
        $window.on('mouseup touchend', onMouseUpThis);
        normalizedOptions.data['event'] = e;
        normalizedOptions.onStart(normalizedOptions.data);
    };
    const handle = getElement(options?.$handle);
    if (handle) {
        return handle
            .off('mousedown touchstart', startDrag)
            .on('mousedown touchstart', startDrag);
    }
    return handle;
};
export class DefMap {
    fn;
    map;
    constructor(fn) {
        this.fn = fn;
        this.map = new Map();
    }
    get(key) {
        let val = this.map.get(key);
        if (val === undefined) {
            val = this.fn();
            this.map.set(key, val);
        }
        return val;
    }
    set(key, val) {
        return this.map.set(key, val);
    }
    push(key, newVal) {
        const valObj = this.get(key);
        if (Array.isArray(valObj)) {
            valObj.push(newVal);
        }
        else {
            throw Error('Cannot use append for non-array values');
        }
    }
    add(key, newVal) {
        const valObj = this.get(key);
        if (valObj instanceof Set) {
            valObj.add(newVal);
        }
        else {
            throw Error('Cannot use append for non-set values');
        }
    }
    toMap() {
        return this.map;
    }
}
export const applySearchHighlight = (text, search) => _.map(getSearchMatchingSections(text, search), (match, i) => ({
    tag: 'span',
    key: i,
    cl: match.match ? 'highlight' : undefined,
    text: match.text,
}));
const getSearchMatchingSections = (text, search) => {
    if (text == null) {
        text = '';
    }
    if (!search || search.length === 0) {
        return [{ match: false, text }];
    }
    let haystack = text.toLowerCase();
    search = search.toLowerCase();
    const result_indices = Do(() => {
        const indices = [];
        let index_offset = 0;
        while (haystack.indexOf(search) !== -1) {
            const new_index = haystack.indexOf(search) + index_offset;
            indices.push(new_index);
            const index_offset_delta = haystack.indexOf(search) + search.length;
            index_offset += index_offset_delta;
            haystack = haystack.substring(index_offset_delta);
        }
        return indices;
    });
    const sections = [
        {
            match: false,
            text: text.substring(0, result_indices[0] ?? text.length + 1),
        },
    ];
    result_indices.forEach((index, n) => {
        const match_start = index;
        const match_end = index + search.length;
        sections.push({
            match: true,
            text: text.substring(match_start, match_end),
        });
        const next_match_start = result_indices[n + 1] ?? text.length + 1;
        sections.push({
            match: false,
            text: text.substring(match_end, next_match_start),
        });
    });
    return sections.filter(x => x.text.length > 0);
};
export const objDiff = (objA, objB) => {
    objA = _.cloneDeep(objA);
    const changes = (objAInner, objBInner) => _.transform(objAInner, (result, value, key) => {
        if (!_.isEqual(value, objBInner[key])) {
            result[key] = Do(() => {
                if (_.isObject(value) && _.isObject(objBInner[key])) {
                    return changes(value, objBInner[key]);
                }
                return value;
            });
        }
    }, {});
    return changes(objA, objB);
};
export const isDarkTheme = () => {
    const theme = window.rootUI?.state?.theme ?? window.rootData?.Theme;
    return theme == 'black' || theme == 'dark';
};
//# sourceMappingURL=component-main.js.map